export default "__VITE_ASSET__CNS8lE57__"